// Keep shipping address data independent of the interface language.
export const ADDRESS_LOOKUP_LANGUAGE = "en";
